import { Box, Skeleton, Typography } from '@mui/material';
import { BASE_COLORS } from 'lib/functions/const/colors';
import React from 'react';

interface InfoCardProps {
  icon: React.ReactElement;
  label: string;
  value: string;
  color?: keyof typeof BASE_COLORS;
  pending?: boolean;
}

const InfoCard = ({
  icon,
  label,
  value,
  color = 'blue',
  pending = false,
}: InfoCardProps) => {
  const hexColor = BASE_COLORS[color];
  const backgroundColorWithAlpha = `${hexColor}15`;

  if (pending) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="60%" height={10} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="85%" height={18} />
        </Box>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box
        sx={{
          backgroundColor: backgroundColorWithAlpha,
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {React.cloneElement(icon, {
          sx: { fontSize: '0.8rem', color: hexColor },
        })}
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: '0.65rem' }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          fontWeight="medium"
          sx={{ fontSize: '0.85rem' }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default InfoCard;
